import Vue from 'vue'
import auth from '@/core/auth'
import rest from '@/core/rest'
import packageJson from '@/../../api/package.json'

export default function () {
  window.captureException = err => {
    if (!window.Sentry) {
      return
    }
    window.Sentry.withScope(scope => {
      if (auth && auth.user) {
        scope.setUser(auth.user)
      }
      window.Sentry.captureException(err)
    })
  }

  window.captureMessage = message => {
    if (!window.Sentry) {
      return
    }
    window.Sentry.withScope(scope => {
      if (auth && auth.user) {
        scope.setUser(auth.user)
      }
      window.Sentry.captureMessage(message, 'error')
    })
  }

  if (rest.isLocal()) {
    return
  }

  // Lazy-load Sentry so localhost doesn't pay the bundle/parse cost.
  import('@sentry/vue').then(Sentry => {
    window.Sentry = Sentry

    Sentry.init({
      Vue,
      dsn: 'https://eb969d871ce743da8ed21ea8bad836d5@o250665.ingest.sentry.io/1435895',
      integrations: [],
      attachProps: true,
      sendDefaultPii: true,
      normalizeMaxBreadth: 5000,
      maxValueLength: 512,
      maxBreadcrumbs: 200,
      initialScope: {
        tags: { part: 'frontend' }
      },
      release: 'frontend@' + packageJson.version
    })

    Vue.config.errorHandler = function (err) {
      window.captureException(err)
      throw err
    }
  }).catch(() => {})
}
